module.exports = "/_next/static/images/albany-ny-7277576d286b94649d6a0b448deaecd3.jpg";